<template>
    <div class="image-card">
        <div class="card">

            <div class="card-header">
                <slot name="header">
                    <div v-html="header"></div>
                </slot>
            </div>

            <div class="card-body">

                <slot name="body">
                    <div v-html="body"></div>
                </slot>

            </div>

            <div class="card-footer">
                <slot name="footer">
                    <div v-html="footer"></div>
                </slot>
            </div>

        </div>
    </div>
</template>


<script>
    export default {
        name: "SimpleCard",
        props: {
            header: {
                type: String,
                default: "",
            },
            body: {
                type: String,
                default: "",
            },
            footer: {
                type: String,
                default: "",
            },
        },
        setup() {
            return {};
        },
    };
</script>


<style lang="scss">
    .example-card {
        width: 100%;
        height: 100%;

        a{
            text-decoration: underline;
        }

        .list-none{
            list-style: none;
        }

        .card {
            border: 0px;
            border-radius: 10px;
            padding: 10px;
            height: 100%;
            width: 100%;
        }
        .card-header {
            background-color: unset;
            border: 0px;
            font-size: 1rem;
            font-weight: 600;
        }
        .card-footer {
            background-color: unset;
            border: 0px;
        }
    }
</style>